import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { Percent, Pixel, Rem } from '@edt/util';

@Component({
  selector: 'edt-progress-bar',
  imports: [NgClass],
  template: `
    <div
      class="w-full rounded-full"
      [ngClass]="barClasses()"
      [style.height]="height()">
      <div
        class="rounded-full"
        [ngClass]="progressClasses()"
        [style.width]="percentageValue()"
        [style.height]="height()"></div>
    </div>
  `,
})
export class ProgressBarComponent {
  value = input.required<number>();
  height = input<Pixel | Percent | Rem>('10px');
  barClasses = input('bg-gray-200 dark:bg-gray-700');
  progressClasses = input('bg-[var(--mat-sys-inverse-primary)]');

  protected percentageValue = computed(() => this.value().toFixed(0) + '%');
}
